import { Skeleton } from "@libs/zapi-ui/shadcn";
import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { useProjectStore } from "@/zapi-frontend/stores/project";
import { OverviewHeader } from "../ProjectOverviewIsland/ui/overview/OverviewHeader";
import { SectionCard } from "../ProjectOverviewIsland/ui/overview/SectionCard";

export function HomeGeneratingSkeleton() {
  const { t } = useTranslation("projectHome");
  const { selectedProject, syncOverviewIfNeeded, syncingOverviewProjectId } = useProjectStore();
  if (!selectedProject) return null;

  const isSyncingOverview = syncingOverviewProjectId === selectedProject.id;

  const handleRefresh = async () => {
    if (isSyncingOverview) return;
    try {
      await syncOverviewIfNeeded(selectedProject.id);
    } catch {
      toast.error(t("overview.failedToRefresh"));
    }
  };

  return (
    <div className="w-full h-full flex items-start justify-center overflow-y-auto bg-projectPage">
      <div className="flex flex-col w-full pb-2 gap-2" role="status" aria-label={t("overview.generating")}>
        <OverviewHeader project={selectedProject} onRefresh={handleRefresh} isRefreshing={isSyncingOverview} />

        <SectionCard label={t("overview.opportunityFrame")}>
          <div className="flex flex-col gap-2.5">
            <Skeleton className="h-3.5 w-full" />
            <Skeleton className="h-3.5 w-[45%]" />
            <div className="h-2" />
            <Skeleton className="h-3.5 w-full" />
            <Skeleton className="h-3.5 w-[55%]" />
          </div>
        </SectionCard>

        <SectionCard label={t("overview.successCriteria")}>
          <div className="grid grid-cols-3 gap-4">
            <Skeleton className="h-[260px] w-full" />
            <Skeleton className="h-[260px] w-full" />
            <Skeleton className="h-[260px] w-full" />
            <Skeleton className="h-[72px] w-full" />
            <Skeleton className="h-[72px] w-full" />
            <Skeleton className="h-[72px] w-full" />
          </div>
        </SectionCard>
      </div>
    </div>
  );
}
